import i18n from 'i18next';

/**
 * The channels skeleton's own namespace (SL-1945). The skeleton is in the
 * initial bundle (RouteSkeleton, the agent layout, the router), so it must not
 * import `agent-setup` — the whole setup wizard's copy, which every user would
 * download before any screen. It carries only what the skeleton says.
 * `__tests__/ChannelsSkeleton.test.tsx` keeps the three languages in step.
 */
export const NS = 'channels-skeleton';

export const en = {
  matrix: 'Loading the channels',
  detail: 'Loading the channel',
};
export const es: typeof en = {
  matrix: 'Cargando los canales',
  detail: 'Cargando el canal',
};
export const pt: typeof en = {
  matrix: 'Carregando os canais',
  detail: 'Carregando o canal',
};

// Guarded so importing this module is safe where the i18next singleton isn't
// initialized (the jest runner); in the app it is, before the first render.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
